<template>
  <!-- 自定义套餐 -->
  <div class="packageWrap" v-if="serviceList.length > 0">
    <div class="packageLeft">
      <p class="fs14 fwb" v-if="businessType == 'COMPANY_INCORPORATION'">
        {{ $t("creation.custom") }}
      </p>
      <p class="fs14 fwb" v-if="businessType == 'SERVICE_TRANSFER'">
        {{ $t("creation.customTransfer") }}
      </p>
      <p>
        <span class="fs20 fwb black00">{{ serviceListPriceSum(serviceList, serviceList[0].currency) }}</span>
      </p>
      <div class="pt10">
        <!-- 适用人群 -->
        <p class="fs12">{{ $t("creation.crowd") }}</p>
        <p class="fs12 black88">
          {{ $t("creation.service") }}
        </p>
      </div>
    </div>
    <div class="packageRight">
      <div class="fdr details">
        <div class="mr20">
          <!-- 套餐包含： -->
          <p class="fs12 fwb">
            {{ $t("creation.comboInclude") }}
          </p>
          <ul class="fs12 black45 lh22">
            <li v-for="son in serviceList" :key="`son-${son.id}`">
              <span class="fwb green fs12 el-icon-check"></span>
              {{ getLanguage == "zh" ? son.descriptionCn : son.description }}
              <span v-if="$isNumberLike(son.serviceFee)">({{ priceCurrencyFormat(son.serviceFee, son.currency) }})</span>
              <info-popover
                placement="top"
                :content="getLanguage == 'zh' ? son.serviceScopeCn : son.serviceScope"
                iconClass="ml2 fs13 blackD8"
                v-if="son.serviceScopeCn && son.serviceScope"
              />
            </li>
          </ul>
        </div>
        <!-- 第三方费用 -->
        <div class="mr20">
          <p class="fs12 pt18 lh22">
            <span class="fwb green fs12 el-icon-check"></span>
            {{ $t("creation.priceInclude") }}
          </p>
          <ul class="fs12 black45 lh22">
            <li v-for="part in mergeSameAttrList(serviceList, 'thirdPartyFeeDescription', 'thirdPartyFee')" :key="`part-${part.id}`">
              <span v-if="getLanguage == 'zh' && part.thirdPartyFeeDescriptionCn">- {{ part.thirdPartyFeeDescriptionCn }}</span>
              <span v-if="getLanguage == 'en' && part.thirdPartyFeeDescription">- {{ part.thirdPartyFeeDescription }}</span>
              <span v-if="$isNumberLike(part.thirdPartyFee)">({{ priceCurrencyFormat(part.thirdPartyFee, part.currency) }})</span>
            </li>
          </ul>
        </div>
        <!-- 其他费用 -->
        <div>
          <p class="fs12 pt18 lh22">
            <span class="fwb green fs12 el-icon-check"></span>
            {{ $t("creation.otherExpenses") }}
          </p>
          <ul class="fs12 black45 lh22">
            <li v-for="other in mergeSameAttrList(serviceList, 'otherFeeDescription', 'otherFee')" :key="`other-${other.id}`">
              <span v-if="getLanguage == 'zh' && other.otherFeeDescriptionCn">- {{ other.otherFeeDescriptionCn }}</span>
              <span v-if="getLanguage == 'en' && other.otherFeeDescription">- {{ other.otherFeeDescription }}</span>
              <span v-if="$isNumberLike(other.otherFee)">({{ priceCurrencyFormat(other.otherFee, other.currency) }})</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import formatMixin from "@/mixins/formatMixin";
import priceCountMixin from "@/mixins/priceCountMixin";
import { mapGetters } from "vuex";
export default {
  mixins: [formatMixin, priceCountMixin],
  props: {
    businessType: {
      type: String,
      default: () => "",
    },
    goodsList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters("language", ["getLanguage"]),
    serviceList() {
      const list = this.goodsList?.map(item => item.service) || [];
      return list;
    },
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.packageWrap {
  display: flex;
  width: 100%;
  padding: 16px;
  background-color: #fdf6ec;

  .packageLeft {
    padding-right: 16px;
    max-width: 250px;
  }

  .packageRight {
    padding-left: 16px;
    border-left: 1px solid #e4e7ed;
  }
}
</style>
